import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { SharedService } from '../shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  contactForm: FormGroup;
  sevices;
  solution;
  shortInfo;
  isOpen = true;

  showNavigationArrows = false;

  videoModalOpen = false;
  selectedVideo: any = null;
  videos = [
    {
      title: 'Engineering the Business Possibilities',
      description: 'Empowering businesses to transform, scale, and innovate through cutting-edge cloud, data, and AI solutions.',
      thumbnail: 'assets/images/unlocking_business_potential.png',
      videoUrl: 'assets/videos/Unlocking_Business_Potential.mp4'
    },
    {
      title: 'Inside Intelligent RevenueMaximizers',
      description: 'Explore a feature-rich platform combining Al-driven recommendations, configurable workflows, and powerful dashboards to maximize revenue.',
      thumbnail: 'assets/images/RMRevenue.png',
      videoUrl: 'assets/videos/RevenueMaximizer_Unlock Revenue_Potentials.mp4'
    },
    {
      title: 'Power Your Teams with Expert Talent',
      description: 'Seamlessly integrate experienced professionals into your teams to scale faster and deliver better.',
      thumbnail: 'assets/images/ArkedgeStaffingServices.png',
      videoUrl: 'assets/videos/Arkedge_Staffing_Service_Final.mp4'
    },
    {
      title: 'Unlocking Hidden Revenue Potential',
      description: 'Discover hidden revenue opportunities by analyzing billing patterns, anomalies, and missed charges with a scalable SaaS solution.',
      thumbnail: 'assets/images/RevolutionizingHealthcard.png',
      videoUrl: 'assets/videos/Revolutionizing_Healthcare Billing_with_RevenueMaximizer.mp4'
    },
  ];

  slideConfig = {
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  };

  slideConfig2 = {
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: `<div class='slick-prev slick-arrow'>  <i class="icon icon-large">
    <svg focusable="false">
      <use xlink:href="#icon_arrowLeft"></use>
    </svg>
  </i></div>`,
    nextArrow: `<div class='slick-next slick-arrow'>  <i class="icon icon-large">
    <svg focusable="false">
      <use xlink:href="#icon_arrowRight"></use>
    </svg>
  </i></div>`,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 960,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  };

  videoSlideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: `<div class='slick-prev slick-arrow'>  <i class="icon icon-large">
    <svg focusable="false">
      <use xlink:href="#icon_arrowLeft"></use>
    </svg>
  </i></div>`,
    nextArrow: `<div class='slick-next slick-arrow'>  <i class="icon icon-large">
    <svg focusable="false">
      <use xlink:href="#icon_arrowRight"></use>
    </svg>
  </i></div>`,
    infinite: true,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2,
          arrows: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: true
        }
      }
    ]
  };

  constructor(
    private router: Router, 
    private sharedservice: SharedService, 
    private fb: FormBuilder,
    private toastr: ToastrService
    ) {
    this.sevices = [
      {
        title: 'Technology',
        color: '#faddbe',
        description: ' ',
        icon: '#icon_technology'
      },
      {
        title: 'Travel & Hospitality',
        color: '#fdb6b6',
        description: ' ',
        icon: '#icon_travel'
      },
      {
        title: 'Government & Nonprofit',
        color: '#cce5a2',
        description: ' ',
        icon: '#icon_GovernmentNonprofit'
      },
      {
        title: 'Financial Services',
        color: '#bdd3ff',
        description: ' ',
        icon: '#icon_financialServices'
      },
      {
        title: 'Energy & Utilities',
        color: '#f0c1c1',
        description: ' ',
        icon: '#icon_EnergyUtilities'
      },
      {
        title: 'Industrial Manufacturing',
        color: '#b7bdf6',
        description: ' ',
        icon: '#icon_IndustrialManufacturing'
      }
    ];
    this.solution = [
     {
        title: 'Software Engineering',
        titlelink: 'ProductEngineering',
        color: 'blue',
        list : [
          {name: 'Product Engineering'},
          {name: 'Application Development'},
          {name: 'UX/UI Development'},
          {name: 'Software Testing & QA'}
        ],
        description: 'Software engineering is a concept in and of itself, but to better understand it, you need to know what each part of the term means before you can fully understand how they operate together. It can be difficult to understand, even though it does seem straightforward.',
        icon: '#icon_softEngg'
      },
      {
        title: 'Data Services',
        titlelink: 'DataEngineering',
        color: 'red',
        list : [
          {name: 'Data Engineering'},
          {name: 'Data Management'},
          {name: 'Data Science'},
          {name: 'Cloud Computing'}
        ],
        description: 'Data Services is the practice of collecting, keeping, and using data securely, efficiently, and cost-effectively. The goal of data management is to help people, organizations, and connected things optimize the use of data within the bounds of policy and regulation.',
        icon: '#icon_mgmt'
      },
      {
        title: 'GCC & ODC Solutions',
        titlelink: 'GCCODCSolutions',
        color: 'green',
        list : [
          {name: 'ODC Setup & Scaling'},
          {name: 'GCC Capability Development'},
          {name: 'Dedicated Engineering Teams'},
          {name: 'Operating Model Evolution'}
        ],
        description: 'GCC & ODC Solutions are designed to help organizations optimize their operations and achieve their business objectives. These solutions provide a comprehensive approach to managing and scaling operations, enabling organizations to improve efficiency, reduce costs, and enhance customer satisfaction.',
        icon: '#icon_gcc'
      },
      {
        title: 'IT Staffing & Training',
        titlelink: 'StaffingServices',
        color: 'yellow',
        list : [
          {name: 'Staffing Services'},
          {name: 'Industries'},
          {name: 'Courses'},
          {name: 'Program Calendar'}
        ],
        description: `Develop the skills your workforce needs to compete and win. Our curated learning pathways help close knowledge gaps and drive measurable outcomes. Whether you're a team of 5 or 50,000, We offers flexible options to work with your eLearning goals and budgets.`,
        icon: '#icon_training'
      },
    ];
    // create form
    this.contactForm = this.fb.group({
      name: ['', Validators.required ],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: [null, Validators.compose([Validators.required])],
      subject: ['', Validators.required],
      message: ['', Validators.required]
   });
  }


  getFormValidation(fieldName) {
    if(this.contactForm.get(fieldName).errors && this.contactForm.get(fieldName).touched) {
      if(this.contactForm.get(fieldName).errors.required) {
        return "required";
      } else  if(this.contactForm.get(fieldName).errors.email) {
        return "invalid";
      }
    }
    return false
  }


  onSubmitContactForm() {
    if(this.contactForm.valid) {
      this.toastr.success("Your Message is Sent.");
      this.contactForm.reset();
    } else {
      this.contactForm.markAllAsTouched()
      this.toastr.error("Please fill mandatory information");
      // if(this.contactForm.get("name").invalid) {
      //   this.toastr.error("Please fill your name.")
      // } else if(this.contactForm.get("email").invalid) {
      //   if(this.contactForm.get("email").errors.required) {
      //     this.toastr.error("Please fill your email address.");
      //   } else {
      //     this.toastr.error("Email address is Invalid");;
      //   }
      // } else if(this.contactForm.get("phone").invalid) {
      //   this.toastr.error("Please fill your Phone Number.");
      // } else if(this.contactForm.get("subject").invalid) {
      //   this.toastr.error("Please fill the subject of message.");
      // } else if(this.contactForm.get("message").invalid) {
      //   this.toastr.error("Please fill the message.");
      // }
    }
  }

  openVideo(video) {
    this.selectedVideo = video;
    this.videoModalOpen = true;
  }

  closeVideo() {
    this.videoModalOpen = false;
    this.selectedVideo = null;
  }

  getUrl(i, title){
  if(title == 'ProductEngineering'){
    this.router.navigateByUrl('/software-engineering'); 
    this.sharedservice.nextMessage(i, 'ProductEngineering')
  }
  else if(title == 'DataEngineering'){
    this.router.navigateByUrl('/data-services'); 
    this.sharedservice.nextMessage(i, 'DataEngineering')
  }
  else if(title == 'GCCODCSolutions'){
    this.router.navigateByUrl('/gcc-odc-solutions');
    this.sharedservice.nextMessage(i, 'GCCODCSolutions')
  }
  else if(title == 'StaffingServices'){
    this.router.navigateByUrl('/staffing-services'); 
    this.sharedservice.nextMessage(i, 'StaffingServices')
  } 
}
  // images = [62, 83, 466, 965, 982, 1043, 738].map((n) => `https://picsum.photos/id/${n}/900/500`);

  banner = [
    {
      title: 'AI Engineering for the Autonomous Enterprise',
      title_2: '',
      description: 'Intelligent automation powered by AI agents that think, act, and execute.',
      icon:"#icon_banner_1"
    },
    {
      title: 'Customized Solutions',
      title_2: 'For Dynamic Business',
      description: 'Offers cutting edge technology solutions for specific business needs.',
      icon:"#icon_banner_2"
    },
    {
      title: 'Cloud & DevOps Tech Services to keep your business ahead of the curve',
      title_2: '',
      description: 'Digital business solutions built for a strong growth with personal attention of project management at super accessible prices.',
      icon:"#icon_banner_3"
    },
    {
      title: 'Designing digital-first',
      title_2: 'Technologies for the future growth',
      description: `We create digitally connected innovative solutions to enable business growth with emerging technologies.`,
      icon:"#icon_banner_4"
    },
    {
      title: 'Product Engineering & Experience Design for delightful user experience',
      title_2: '',
      description: 'Digital business solutions built for a strong growth with personal attention of project management at super accessible prices.',
      icon:"#icon_banner_5"
    },
    {
      title: 'GCC & ODC Solutions for global delivery and offshore development',
      title_2: '',
      description: 'We provide global delivery and offshore development solutions to help businesses scale and expand their operations.',
      icon:"#icon_banner_6"
    }
  ];

  partner = [
    {img: 'assets/images/client'},
    {img: 'assets/images/client'},
    {img: 'assets/images/client'},
    {img: 'assets/images/client'},
    {img: 'assets/images/client'},
    {img: 'assets/images/client'},
    {img: 'assets/images/client'},
    {img: 'assets/images/client'},
    {img: 'assets/images/client'}
  ];

  testimonials = [
    {
      clientView: 'Highly recommend Arkedge for their exceptional web development services. Their team is professional, skilled and attentive to detail. They provided clear communication throughout the project and delivered a beautiful, functional product within our timeline and budget. I look forward to working with them again in the future.',
      clientName: 'Executive Director, investment Banking, USA'
    },
    {
      clientView: 'Arkedge’s data management services are outstanding. They have a deep understanding of data governance and take a comprehensive approach to managing data. Their team is knowledgeable, organized, and efficient. They helped us streamline our data processes and provided a secure environment for our sensitive data. Their commitment to quality makes them an excellent choice for any organization in need of data management services. I highly recommend Arkedge for their expertise and professionalism.',
      clientName: 'Senior Director, Data & Analytics, major credit card company, USA'
    },
    {
      clientView: 'Partnering with Arkedge has been a great decision. They have a strong track record of delivering quality services, and their expertise has been invaluable to us. Their collaborative approach and dedication to client satisfaction make them an ideal partner. We look forward to continuing our partnership with Arkedge for years to come.',
      clientName: 'Co-Founder, Pentaknot Solutions, India'
    },
    {
      clientView: 'We were looking for a partner who could lay a fair bit of judgment and curation path to convert manual sketches into code in real-time without human involvement. Arkedge exactly understood our imagination and promptly came up with a hyper-personalized structured solution which was just a commendable job done for us.',
      clientName: 'Chief Architect, Bell Canada, Canada'
    },
    {
      clientView: 'It was a pleasure to work with Arkedge in our high-paced dynamic environment. This is the best and most professional UX company we have worked with. Their top-notch team of highly skilled designers and programmers was just amazing! Arkedge’s quick turnaround time, communication, and responsiveness has reserved a space for our future projects.',
      clientName: 'Senior IT consultant, ARM Solution, KSA'
    },
    {
      clientView: 'Arkedge has been great help to build complex data pipeline and help us to discover new revenue potentials for healthcare billing cycle.',
      clientName: 'SVP, Travelers, Texas USA'
    },
    {
      clientView: 'We found a technology partner in Arkedge to streamline our digital automation process and helped us define transformation roadmap to move system from legacy ecosystem to more adaptable microservices application architecture to scale for future needs.',
      clientName: 'Founder, CTO, Indicsoft, India'
    },
    {
      clientView: 'We were facing challenges to meet our business demand prior to automating our account payable process. Arkedge helped us to streamline our business processes and built an enterprise integration framework to automate account payable and invoice generation process that reduces our cycle from couple of weeks to few days.',
      clientName: 'Executive Vice President, Finance, top financial company, USA'
    },
    {
      clientView: 'Working with Arkedge has been a great business decision for us. We were looking to automate manual process for marketing campaign and reduce the execution cycle to few hours which were taking days leading to loss of prospective valuable customers.',
      clientName: 'Founder, CTO, Indoqubix, India'
    },
    {
      clientView: 'Arkedge offers us strong expertise in delivery management, including a milestone driven planning to roll out functional modules and provide user training to quickly onboard them on business application.',
      clientName: 'General Manager, ARB, Muscat Oman'
    },
    {
      clientView: 'Thanks to Arkedge innovative approach, traffic on our client website has increased by 120% leading to a better conversion rate. The team has supported us continuously during peak traffic and helped us achieve our business goals.',
      clientName: 'Enterprise Infrastructure PMO Leader, Texas, USA'
    },
    {
      clientView: 'We have worked with Arkedge for various successful project engagements. Their team has done exceptional work in gathering requirements, followed agile methodologies, closely worked with business stakeholders and adaptable to usually changing requirements meticulously. We are looking forward to many more engagements with them.',
      clientName: 'Head Finance & commercials, TATA Hitachi, Japan'
    },
    {
      clientView: 'Arkedge worked as our offshore technology partner to build the data engineering product for auto ingestion, tagging and classification for our thousands of documents. This helped us immensely in enriching the knowledge base repository for our medical servicing partners.',
      clientName: 'SVP Engineering, Flywire USA'
    },
    {
      clientView: 'We have a complex use case that requires an API integration framework to build merchant risk profiling pipeline before they can be onboarded. Arkedge offered us a great team with a mix of strong technical professionals and domain consultants and delivered the solution successfully.',
      clientName: 'SVP, Citi Bank, India'
    },
    {
      clientView: 'Arkedge has become a strategic partner for us as they worked with us on mission critical initiatives. Their team collaborated with us to refine our strategic roadmap and delivered critical architectural components and modules for CRM system.',
      clientName: 'Founder, Web All Solutions, India'
    },
];


projects = [
  {
    gridClass: 'col-lg-6 col-md-6 col-sm-6 col-xs-12',
    imgPath: 'assets/images/project',
    title: 'DATANEST',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
  },
  {
    gridClass: 'col-lg-3 col-md-3 col-sm-6 col-xs-12',
    imgPath: 'assets/images/project',
    title: 'DATANEST',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
  },
  {
    gridClass: 'col-lg-3 col-md-3 col-sm-6 col-xs-12',
    imgPath: 'assets/images/project',
    title: 'DATANEST',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
  },
  {
    gridClass: 'col-lg-3 col-md-3 col-sm-6 col-xs-12',
    imgPath: 'assets/images/project',
    title: 'DATANEST',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
  },
  {
    gridClass: 'col-lg-3 col-md-3 col-sm-6 col-xs-12',
    imgPath: 'assets/images/project',
    title: 'DATANEST',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
  }
];



  paused = false;
  unpauseOnArrow = false;
  pauseOnIndicator = false;
  pauseOnHover = true;

  @ViewChild('carousel', { static: true }) carousel: NgbCarousel;

  togglePaused() {
    if (this.paused) {
      this.carousel.cycle();
    } else {
      this.carousel.pause();
    }
    this.paused = !this.paused;
  }

  onSlide(slideEvent: NgbSlideEvent) {
    if (this.unpauseOnArrow && slideEvent.paused &&
      (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)) {
      this.togglePaused();
    }
    if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
      this.togglePaused();
    }
  }

btnClick = function() {
    this.router.navigateByUrl('/contact');
};

viewMore = function() {
  this.router.navigateByUrl('/industries');
};

btnOurProduct = function() {
  this.router.navigateByUrl('/product');
};

lernmore = function(i: number) {
  if(i == 0) {
    // for AI Engineering slide redirect
    this.router.navigateByUrl('/ai');
  } else if (i==1 || i==3){
    this.router.navigateByUrl('/advance-solution');
  } else if(i == 2) {
    this.router.navigateByUrl('/data-services/cloud-computing');
  } else if(i == 4){
    this.router.navigateByUrl('/software-engineering');
  } else {
    this.router.navigateByUrl('/gcc-odc-solutions');
  }
};

addCookies(){
  this.isOpen = !this.isOpen;
}

}

